// V4-FRONT-ANY-USAGE batch 5 2026-05-28
import { History, RotateCcw } from 'lucide-react';
import { Button } from '../../ui/button';
// V4-CONSTANTS-AUDIT-FRONTEND 2026-05-28
import { formatDayMonthTime } from '../../../utils/dateUtils';
import type { TranslationKeys } from '../../../i18n/fr';

interface Version {
  version_id: string;
  content: string;
  created_at: string;
  source: string;
  summary?: string;
}

interface PositioningHistoryViewProps {
  versions: Version[];
  isLoadingVersions: boolean;
  onRefresh: () => void;
  onRestore: (versionId: string) => void;
  t: TranslationKeys;
}

/**
 * Vue historique des versions du positionnement
 * Extrait de PositioningTab pour améliorer la maintenabilité
 */
export function PositioningHistoryView({
  versions,
  isLoadingVersions,
  onRefresh,
  onRestore,
  t,
}: PositioningHistoryViewProps) {
  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <History className="w-5 h-5" style={{ color: 'var(--color-primary)' }} />
          <h3 className="font-medium">{t.positioning?.historyTitle || 'Historique des versions'}</h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onRefresh}
          disabled={isLoadingVersions}
        >
          <RotateCcw className={`w-4 h-4 ${isLoadingVersions ? 'animate-spin' : ''}`} />
        </Button>
      </div>
      
      {versions.length === 0 ? (
        <p className="text-sm text-center py-8" style={{ color: 'var(--color-text-secondary)' }}>
          {t.positioning?.noVersions || 'Aucune version antérieure'}
        </p>
      ) : (
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {versions.map((version) => (
            <div
              key={version.version_id}
              className="p-3 rounded-lg cursor-pointer hover:bg-opacity-80 transition-colors"
              style={{ backgroundColor: 'var(--color-surface-hover)' }}
              onClick={() => onRestore(version.version_id)}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium px-2 py-0.5 rounded-full" 
                  style={{ backgroundColor: 'var(--color-primary)', color: 'white' }}>
                  {version.source}
                </span>
                <span className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
                  {formatDayMonthTime(version.created_at)}
                </span>
              </div>
              <p className="text-sm truncate" style={{ color: 'var(--color-text-primary)' }}>
                {version.content.substring(0, 100)}...
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
